import { globalQueryKeyReferralCode } from '@/constants/globalQueryKeyMaps';

const STORAGE_KEY = 'mc_referral_code';

/**
 * Saves the referral code to local storage
 * @param code The referral code to save
 */
export const saveReferralCode = (code: string): void => {
  if (typeof window !== 'undefined' && code) {
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (error) {
      console.error('Failed to save referral code to local storage:', error);
    }
  }
};

/**
 * Gets the referral code from local storage
 * @returns The referral code or null if not found
 */
export const getReferralCode = (): string | null => {
  if (typeof window !== 'undefined') {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      console.error('Failed to get referral code from local storage:', error);
    }
  }
  return null;
};

/**
 * Clears the referral code from local storage
 */
export const clearReferralCode = (): void => {
  if (typeof window !== 'undefined') {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Failed to clear referral code from local storage:', error);
    }
  }
};
